import React from 'react';
import { Link } from 'react-router-dom';

import { getAdvancedSettings } from '../advancedSettings';
import { getBackgroundSettings } from '../backgroundSettings';

import classes from './PageBuilderBanner.module.scss';
import { Banner } from './components';
import { BannerType } from './bannerConfigAggregator';

type PageBuilderBannerProps = BannerType;

/**
 * Return the PB Banner
 * @param props
 * @constructor
 */
export function PageBuilderBanner(props: PageBuilderBannerProps) {
    /**
     * Configure the styles requires for the Block
     */
    const backgroundStyles = getBackgroundSettings<PageBuilderBannerProps>({ ...props });
    const advancedSettings = getAdvancedSettings<PageBuilderBannerProps>(props);

    const layoutStyles = {
        minHeight: props.minHeight,
    };

    const backgroundImageStyles = `
        #${props.uniqueID} {
            background-image: url(${props.mobileImage ?? props.desktopImage})
        }
    
        @media (min-width: 900px) {
            #${props.uniqueID} {
                background-image: url(${props.desktopImage})
            }
        }
    `;

    /**
     * Render the Divider Block UI
     */
    const renderBanner = () => {
        return (
            <>
                {props.desktopImage && <style dangerouslySetInnerHTML={{ __html: backgroundImageStyles }} />}
                <Banner
                    {...props}
                    styles={{
                        ...backgroundStyles,
                        ...advancedSettings,
                        ...layoutStyles,
                    }}
                />
            </>
        );
    };

    /**
     * Render the Divider Block  as a banner or with a link wrapper
     */
    return (
        <>
            {!props.link && renderBanner()}

            {props.link && (
                <Link
                    to={props.link ?? '/'}
                    target={props.openInNewTab ? '_blank' : ''}
                    className={classes['link']}
                    aria-label={props.altText || 'Banner Link'}
                >
                    {renderBanner()}
                </Link>
            )}
        </>
    );
}
